import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/partner/$organization/search')({
  component: () => <Navigate replace search to="/bo/search" />,
})
